// test340
(340 && 0);
